<script setup>
   import { generateNumericID } from '@/composables/strings'

   const props = defineProps({
      waiting: {
         type: Boolean,
         default: false
      },
      disabled: {
         type: Boolean,
         default: false
      },
      type: {
         type: String,
         default: 'submit'
      },
      icon: {
         type: [String, Boolean],
         default: 'fas fa-save'
      },
      size: {
         type: String,
         default: 'sm'
      }
   })

   const emit = defineEmits(['clicked'])

   /**
      * Function: emitClicked
      * @description Emits the click event with the
      * type of button.
   */
   const emitClicked = () => emit('clicked', generateNumericID(10))

</script>

<template>
   <button @click="emitClicked" :type="type" class="btn btn-primary d-flex align-items-center gap-2" :class="`btn-${size}`" :disabled="disabled || waiting">
      <template v-if="waiting">
         <Loader size="20" color="#fff" />
         <slot name="waitingLabel"></slot>
      </template>
      <template v-else>
         <template v-if="icon != false">
            <FontAwesomeIcon :icon="icon" />
         </template>
         <slot name="label"></slot>
      </template>
   </button>
</template>